/**
   *  Loại phân khai dự toán
   */
export default {
  ByQuarter: 2 ,//Phân khai theo Quý
  ByMonth: 3 ,//Phân khai theo tháng
  None: 1, //Không phân khai
};